import Vue from 'vue'
import Router from 'vue-router'

import menu from '@/components/page/menu/menu'
import login from '@/components/page/login/login'
import forgetPass from '@/components/page/login/forgetPass'
import loginRegist from '@/components/page/login/loginRegist'
import registAgreement from '@/components/page/login/registAgreement'
import no from '@/components/page/404'
import loginMenu from '@/components/page/menu/loginMenu'
import template from '@/components/page/contract/template'
import navLeft from '@/components/nav/nav-left'
// import contractSinMenu from '@/components/page/contract/con_menu'
import ukeyVideo from '@/components/ukeyVideo/index'


import ukey from '@/components/ukey/ukey'
import contractSin from '@/components/page/contract/contractSin'
import detalContract from '@/components/page/contract/detal_contract'
import myTemplate from '@/components/page/contract/me_template'
import signContract from '@/components/page/contract/sign_contract'
//import signContract from '@/components/preview/preview'
import templateDetailPdf from '@/components/page/contract/templateDetailPdf'
import Contemplate from '@/components/page/contract/template'
import OfflineSin from '@/components/page/contract/offline_sin'
import vipCenter from '@/components/page/vip/vipCenter'

import aboutUs from '@/components/page/vip/aboutUs'
import perSeal from '@/components/page/seal/personalSeal'
import entSeal from '@/components/page/seal/enterpriseSeal'
import sealList from '@/components/page/seal/sealList'

import sealListZhang from '@/components/page/seal/sealListZhang'
import ukeyList from '@/components/page/seal/ukeyList'

import signInsp from '@/components/page/signature/sign_insp'
import changePassWord from '@/components/page/login/changePassWord'
import buyCert from '@/components/page/certificate/buyCert'
import authen from '@/components/page/authentication/authen'
import certList from '@/components/page/certificate/certList'
import payCert from '@/components/page/certificate/payCert'
import payUkey from '@/components/page/certificate/payUkey'
import myOrder from '@/components/page/vip/myOrder'
import newsDetal from '@/components/page/news/newsDetal'
import newsList from '@/components/page/news/newsList'
import addOnePerSeal from '@/components/page/seal/addOnePerSeal'
import anLi from '@/components/page/news/anLi'
import uploadInsp from '@/components/page/signature/upload_insp'
import cnde from '@/components/page/login/cnde'
import youKe from '@/components/page/signature/yk_jy'


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'menu',
            component: menu,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/navLeft',
            name: 'navLeft',
            component: navLeft,
            children: [
                //合同
                {
                    path: '/contractSin',
                    name: 'contractSin',
                    component: contractSin,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/myTemplate',
                    name: 'myTemplate',
                    component: myTemplate,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/Contemplate',
                    name: 'Contemplate',
                    component: Contemplate,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/OfflineSin',
                    name: 'OfflineSin',
                    component: OfflineSin,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/templateDetailPdf',
                    name: 'templateDetailPdf',
                    component: templateDetailPdf,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/detalContract',
                    name: 'detalContract',
                    component: detalContract,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/signContract',
                    name: 'signContract',
                    component: signContract,
                    meta: {
                        requireAuth: true,
                    },
                },
                // vip
                {
                    path: '/vipCenter',
                    name: 'vipCenter',
                    component: vipCenter,
                    meta: {
                        requireAuth: true,
                    },
                },

                {
                    path: '/ukeyList',
                    name: 'ukeyList',
                    component: ukeyList,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/aboutUs',
                    name: 'aboutUs',
                    component: aboutUs,
                    meta: {
                        requireAuth: false,
                    },
                },
                {
                    path: '/myOrder',
                    name: 'myOrder',
                    component: myOrder,
                    meta: {
                        requireAuth: true,
                    },
                },
                //印章管理
                {
                    path: '/perSeal',
                    name: 'perSeal',
                    component: perSeal,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/entSeal',
                    name: 'entSeal',
                    component: entSeal,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/sealList',
                    name: 'sealList',
                    component: sealList,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/sealListZhang',
                    name: 'sealListZhang',
                    component: sealListZhang,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/addOnePerSeal',
                    name: 'addOnePerSeal',
                    component: addOnePerSeal,
                    meta: {
                        requireAuth: true,
                    },
                },
                //签章 检验
                {
                    path: '/signInsp',
                    name: 'signInsp',
                    component: signInsp,
                    meta: {
                        requireAuth: false,
                    },
                },
                // 登录  修改密码
                {
                    path: '/changePassWord',
                    name: 'changePassWord',
                    component: changePassWord,
                    meta: {
                        requireAuth: true,
                    },
                },
                //证书服务
                {
                    path: '/buyCert',
                    name: 'buyCert',
                    component: buyCert,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/certList',
                    name: 'certList',
                    component: certList,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/payCert',
                    name: 'payCert',
                    component: payCert,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/payUkey',
                    name: 'payUkey',
                    component: payUkey,
                    meta: {
                        requireAuth: true,
                    },
                },
                //认证
                {
                    path: '/authen',
                    name: 'authen',
                    component: authen,
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    path: '/no',
                    name: 'no',
                    component: no
                },

            ]
        },
        //登录
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/forgetPass',
            name: 'forgetPass',
            component: forgetPass,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/loginRegist',
            name: 'loginRegist',
            component: loginRegist,
            meta: {
                requireAuth: false,
                keepAlive: true
            },
        },
        {
            path: '/registAgreement',
            name: 'registAgreement',
            component: registAgreement,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/ukeyVideo',
            name: 'ukeyVideo',
            component: ukeyVideo,
            meta: {
                requireAuth: false,
            },
        },

        {
            path: '/downloadDrive',
            name: 'downloadDrive',
            redirect:"downloadDriver",
            meta: {
                requireAuth: false,
            },
            
        },
        {
            path: '/loginMenu',
            name: 'loginMenu',
            component: loginMenu,
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/cnde',
            name: 'cnde',
            component: cnde,
            meta: {
                requireAuth: false,
            },
        },
        //新闻
        {
            path: '/newsDetal',
            name: 'newsDetal',
            component: newsDetal,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/newsList',
            name: 'newsList',
            component: newsList,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/anLi',
            name: 'anLi',
            component: anLi,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/uploadInsp',
            name: 'uploadInsp',
            component: uploadInsp,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/youKe',
            name: 'youKe',
            component: youKe,
            meta: {
                requireAuth: false,
            },
        },
        //ukey
        {
            path: '/ukey',
            name: 'ukey',
            component: ukey,
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/no',
            name: 'no',
            component: no,
            meta: {
                requireAuth: false,
            },
        },

    ],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js